import { gql } from "@apollo/client";

export const QUERY_GET_USER_TO_PROCESS_BY_STAGE = gql`
  query QUERY_GET_USER_TO_PROCESS_BY_STAGE(
    $patientId: uuid, 
    $processId: Int, 
    $stagesIds: [String!]
  ) {
    userToProcessHistory(where: {userToProcess: {userId: {_eq: $patientId}}, processId: {_eq: $processId}, stageId: {_in: $stagesIds}}, order_by: {created_at: desc}, limit: 1) {
      id
      processId
      stageId
      doctorId
      descript
      created_at
      userToProcessId
    }
  }
`

export const QUERY_GET_USER_TO_PROCESS_HISTORY = gql`
  query QUERY_GET_USER_TO_PROCESS_HISTORY($patientId: uuid) {
    userToProcess(where: {userId: {_eq: $patientId}}) {
      descript
      id
      created_at
      isAcepted
      process {
        descript
        nameKey
        processName
      }
      processStage {
        id
        stageName
      }
      userToProcessHistories(order_by: {created_at: desc}) {
        id
        processId
        stageId
        doctorId
        descript
        created_at
        userToProcessId
        latestCustomFormId
        processStage {
          id
          stageName
        }
        doctor {
          name
          lastname
          picture
          gender
        }
      }
      userToProcessCalendars {
        created_at
        dateTime
        descript
        id
        isAccepted
        isNotify
        name
        place
        user {
          documentNumber
          email
          lastname
          name
          picture
          documentType
        }
      }
    }
  }
`

export const QUERY_GET_USER_TO_PROCESS_HISTORY_FILTERS = gql`
  query QUERY_GET_USER_TO_PROCESS_HISTORY(
    $patientId: uuid, 
    $processId: Int,
    $initialDate: timestamptz, 
    $finalDate: timestamptz, 
  ) {
    userToProcessHistory(where: {created_at: {_gte: $initialDate, _lte: $finalDate}, userToProcess: {userId: {_eq: $patientId}}, processId: {_eq: $processId}}, order_by: {created_at: desc}) {
      id
      processId
      stageId
      doctorId
      descript
      created_at
      userToProcessId
      latestCustomFormId
      customFormFieldChanges
      processStage {
        id
        stageName
      }
      doctor {
        name
        lastname
        picture
        gender
      }
    }
  }
`

export const QUERY_GET_USER_TO_PROCESS_HISTORY_BY_PATIENT = gql`
  query QUERY_GET_USER_TO_PROCESS_HISTORY_BY_PATIENT(
    $patientId: uuid!
  ) {
    userToProcessHistory(where: {
      userToProcess: {
        userId: {
          _eq: $patientId
        }
      }, 
    }
    order_by: {
      created_at: desc
    }
  ) {
      id
      processId
      stageId
      doctorId
      descript
      created_at
      userToProcessId
      latestCustomFormId
      customFormFieldChanges
      callId
      call {
        id
        status
        date
        duration
        startTime
        endTime
        phoneNumber
        transcription
        callCost
        transcriptionCost
        doctorId
        userId
        userToProcessId
      }
      userToProcess {
        descript
        id
        created_at
        isAcepted
        process {
          descript
          nameKey
          processName
        }
      }
      doctor {
        name
        lastname
        picture
        gender
      }
    }
  }
`
export const QUERY_GET_USER_TO_PROCESS_HISTORY_GENERAL_NOTE = gql`
  query QUERY_GET_USER_TO_PROCESS_HISTORY_GENERAL_NOTE($patientId: uuid!) {
    userToProcessHistory(
      where: {
        isGeneralNote: {
          _eq: true
        }, 
        userToProcess: {
          userId: {_eq: $patientId}}}) {
      created_at
      customFormFieldChanges
      date
      descript
      doctorId
      id
      isChecked
      isGeneralNote
      latestCustomFormId
      processId
      stageId
      userToProcessId
      doctor {
        name
        lastname
        picture
        gender
      }
    }
  }
`

export const QUERY_GET_USER_TO_PROCESS_HISTORY_AND_CALL_NOTE = gql`
  query QUERY_GET_USER_TO_PROCESS_HISTORY_AND_CALL_NOTE {
    call(order_by: {date: desc}, limit: 1) {
      duration
      startTime
      endTime
      date
    }
    userToProcessHistory(order_by: {created_at: desc}, where: {callId: {_is_null: false}}, limit: 1) {
      callId
      created_at
      date
      descript
      doctorId
      id
      isChecked
      isGeneralNote
      latestCustomFormId
      processId
      stageId
      userToProcessId
    }
  }
`